import { FacetInteraction, SEARCH_CAUSES } from '../types';

export const getAnalyticsCause = (originCause: SEARCH_CAUSES | FacetInteraction) => {
    if (originCause === SEARCH_CAUSES.queryChange) {
        return SEARCH_CAUSES.init;
    }

    return originCause;
};
